import {$, w} from './constants';

//Slider Home ParrotConnect
if( $('#slider-home-parrot').length ){

    let config = {};

    if( $('#slider-home-parrot-mobile').length ){
        config = {
            arrows: true,
            prevArrow: "<div class='arrow arrow-left-home-white'>",
            nextArrow: "<div class='arrow arrow-right-home-white'>",
            dots: false,
            infinite: true,
            autoplay: false,
            pauseOnHover: true,
            autoplaySpeed: 4000,
            speed: 50,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            responsive: [
                {
                    breakpoint: 651,
                    settings: "unslick"
            }]
        }
    }else{
        config = {
            arrows: true,
            prevArrow: "<div class='arrow arrow-left-home-white'>",
            nextArrow: "<div class='arrow arrow-right-home-white'>",
            dots: false,
            infinite: true,
            autoplay: false,
            pauseOnHover: true,
            autoplaySpeed: 4000,
            speed: 50,
            cssEase: 'linear',
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            responsive: [
                {
                    breakpoint: 651,
                    settings: {
                        dots: true,
                        dotsClass: 'dots dots--functions'
                    }
                }
            ]
        }
    }

    $('#slider-home-parrot').slick(config);
}
if( $('#slider-home-parrot-mobile').length ){
    $('#slider-home-parrot-mobile').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left-home-white'>",
        nextArrow: "<div class='arrow arrow-right-home-white'>",
        dots: false,
        infinite: true,
        autoplay: false,
        pauseOnHover: true,
        autoplaySpeed: 4000,
        speed: 50,
        cssEase: 'linear',
        fade: true,
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 651,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    dotsClass: 'dots dots--functions'
                }
            }
        ]
    });
}

//Slider Home Clientes
if( $('#slider-home-clients-mobile').length ){
    $('#slider-home-clients-mobile').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left-home'>",
        nextArrow: "<div class='arrow arrow-right-home'>",
        dots: false,
        infinite: true,
        autoplay: false,
        pauseOnHover: true,
        autoplaySpeed: 4000,
        speed: 50,
        cssEase: 'linear',
        fade: true,
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },
            {
                breakpoint: 651,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    dotsClass: 'dots dots--home'
                }
            }
        ]
    });
}

//Slider Home Prensa
if( $('#slider-home-press').length ){
    $('#slider-home-press').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left-home arrow-left-home--f'>",
        nextArrow: "<div class='arrow arrow-right-home arrow-right-home--f'>",
        dots: true,
        dotsClass: 'dots dots--home',
        infinite: true,
        autoplay: false,
        pauseOnHover: true,
        autoplaySpeed: 4000,
        speed: 10,
        cssEase: 'linear',
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
			{
			  breakpoint: 901,
			  settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
			    }
            },
            {
                breakpoint: 651,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: false,
                    infinite: false,
                }
		}]
    });
}

//Slider ParrotConnect
if( $('#slider-main-parrotconnect').length ){
    $('#slider-main-parrotconnect').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left-home arrow-left-home--f'>",
        nextArrow: "<div class='arrow arrow-right-home arrow-right-home--f'>",
        dots: true,
        dotsClass: 'dots dots--home',
        infinite: true,
        autoplay: false,
        pauseOnHover: true,
        autoplaySpeed: 4000,
        speed: 50,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        responsive: [
			{
			  breakpoint: 901,
			  settings: {
                autoplay: false
			  }
            },{
                breakpoint: 651,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: false,
                    infinite: false,
                }
		}]
    });
}

//Slider ParrotConnect Funciones
if( $('#slider-functions-parrotconnect').length ){
    $('#slider-functions-parrotconnect').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left-home arrow-left-home--pc'>",
        nextArrow: "<div class='arrow arrow-right-home arrow-right-home--pc'>",
        dots: true,
        dotsClass: 'dots dots--home dots--home--pc',
        infinite: true,
        autoplay: false,
        pauseOnHover: true,
        autoplaySpeed: 4000,
        speed: 50,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        responsive: [
			{
			  breakpoint: 901,
			  settings: {
                autoplay: false
			  }
            },{
                breakpoint: 651,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: false,
                    infinite: false,
                }
		}]
    });
}

//Slider ParrotConnect Testimonios
if( $('#slider-testimonios-parrotconnect').length ){
    $('#slider-testimonios-parrotconnect').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left-home arrow-left-home--t'>",
        nextArrow: "<div class='arrow arrow-right-home arrow-right-home--t'>",
        dots: true,
        dotsClass: 'dots dots--home',
        infinite: true,
        autoplay: false,
        pauseOnHover: true,
        autoplaySpeed: 4000,
        speed: 50,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        responsive: [{
                breakpoint: 651,
                settings: {
                    dots: false
                }
		}]
    });
    $("#slider-testimonios-parrotconnect").on("beforeChange", function(event, slick) {
        let currentSlide, player, command;         
        currentSlide = $(slick.$slider).find(".slick-current");
        player = currentSlide.find("iframe").get(0);
        console.log('Estoy reproduciendo: ' + player);
            
        command = {
            "event": "command",
            "func": "pauseVideo"
        };
        if (player != undefined) {
            player.contentWindow.postMessage(JSON.stringify(command), "*");
        }
    });  
}

//Slider testimonios

if($('#slider-testimonials').length){
    $('#slider-testimonials').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left-testimonials'>",
        nextArrow: "<div class='arrow arrow-right-testimonials'>",
        dots: true,
        dotsClass: 'dots dots--testimonials',
        infinite: true,
        autoplay: false,
        pauseOnHover: true,
        speed: 50,
        cssEase: 'linear',
        fade: true,
    })

    if($('#slider-testimonials').find('.testimonials__slide').length <= 1){
        $('#slider-testimonials').find('.dots').addClass('hide');
    }
    
    $("#slider-testimonials").on("beforeChange", function(event, slick) {
        let currentSlide, player, command;         
        currentSlide = $(slick.$slider).find(".slick-current");
        player = currentSlide.find("iframe").get(0);
            
        command = {
            "event": "command",
            "func": "pauseVideo"
        };
        if (player != undefined) {
            player.contentWindow.postMessage(JSON.stringify(command), "*");
        }
    });     
}

//Slider confianza
if($('#slider-confianza').length){
    $('#slider-confianza').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left-testimonials'>",
        nextArrow: "<div class='arrow arrow-right-testimonials'>",
        dots: true,
        dotsClass: 'dots dots--testimonials',
        infinite: true,
        autoplay: false,
        pauseOnHover: true,
        speed: 50,
        cssEase: 'linear',
        fade: true,
    })

    if($(' #slider-confianza').find('.testimonials__slide').length <= 1){
        $('#slider-confianza').find('.dots').addClass('hide');
    }
}

//Slider de trabaja en Parrot
if($('#slider-work-parrot').length){
    $('#slider-work-parrot').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left-work'>",
        nextArrow: "<div class='arrow arrow-right-work'>",
        dots: true,
        dotsClass: 'dots dots--work',
        infinite: true,
        autoplay: true,
        pauseOnHover: true,
        autoplaySpeed: 4000,
        speed: 50,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        responsive: [
			{
			  breakpoint: 901,
			  settings: {
                autoplay: false
			  }
		}]
    });
}

//Slider banner actualizaciones
if($('#slider-updates').length){
    $('#slider-updates').slick({
        arrows: true,
        prevArrow: "<div class='arrow arrow-left-updates'>",
        nextArrow: "<div class='arrow arrow-right-updates'>",
        dots: true,
        dotsClass: 'dots dots--updates',
        infinite: true,
        autoplay: true,
        pauseOnHover: true,
        autoplaySpeed: 5000,
        speed: 50,
        cssEase: 'linear',
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        responsive: [
			{
			  breakpoint: 901,
			  settings: {
                autoplay: false
			  }
		}]
    });
}

//Slider planes
if($('#slider-mobile-planes').length){
    if( w.width() < 901 ){
        $('#slider-mobile-planes').slick({
            arrows: false,
            fade: false,
            infinite: true,
            dotsClass: 'dots dots--home dots--home--pc',
            autoplay: false,
            pauseOnHover: true,
            autoplaySpeed: 4000,
            speed: 50,
            cssEase: 'linear',
            fade: true,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: "unslick"
                },
                {
                    breakpoint: 901,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: true,
                        prevArrow: "<div class='arrow arrow-left-home'>",
                        nextArrow: "<div class='arrow arrow-right-home'>",
                    }
                },
                {
                    breakpoint: 651,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        arrows: false,
                        fade: false,
                        infinite: false
                    }
                }
            ]
        });
    }
}